/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Top10_DescInputs */



/**
* | output |
* | --- |
* | "only top 10 shown" |
*
* @param {Og_Cfg_Top10_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_top10_desc = /** @type {((inputs?: Og_Cfg_Top10_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Top10_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("seul le top 10 affiché")
	if (locale === "es") return /** @type {LocalizedString} */ ("solo se muestran los 10 primeros")
	if (locale === "pt") return /** @type {LocalizedString} */ ("apenas os 10 primeiros são mostrados")
	if (locale === "it") return /** @type {LocalizedString} */ ("mostrati solo i primi 10")
	return /** @type {LocalizedString} */ ("only top 10 shown")
});